import React, { Component } from 'react'
import ClientsStore from '../../stores/ClientsStore'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import ModalUnsavedConfirmation from '../../components/ModalUnsavedConfirmation'
import LoadingWrapper from '../../components/LoadingWrapper'
import ModalError from '../../components/ModalError'
import Toast from '../../components/Toast'
import ClientPrincipalInformation from '../../components/Clients/ClientPrincipalInformation'
import AddressInformation from '../../components/Clients/AddressInformation'
import { Button, Confirm, Grid, Header } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom'
import AuthenticationStore from '../../stores/AuthenticationStore'

@inject('clientsStore')
@withRouter
@observer
class ClientsCreateScreen extends Component {
  static propTypes = {
    authenticationStore: PropTypes.instanceOf(AuthenticationStore),
    clientsStore: PropTypes.instanceOf(ClientsStore),
    history: PropTypes.object
  }

  state = {
    saveConfirm: false
  }

  constructor (props) {
    super(props)
    window.document.title = 'Nouveau client'
    const role = props.authenticationStore.getRoleForControllerAction('clients', 'create')
    if (role !== 'create') {
      props.history.goBack()
    }
    props.clientsStore.newClient()
  }

  handleSaveClient = () => {
    const { clientsStore, history } = this.props
    this.setState({ saveConfirm: false })
    clientsStore.save().then((result) => {
      history.push(`/clients/view/${result.client.id}`)
    })
  }

  handleRevertClient = () => {
    const { clientsStore } = this.props
    clientsStore.revert()
  }

  render () {
    const { clientsStore } = this.props
    const { isSaving } = clientsStore
    const { saveConfirm } = this.state
    return (
      <>
        <ModalUnsavedConfirmation
          when={clientsStore.isDirty}
          onSave={this.handleSaveClient}
          onDiscard={this.handleRevertClient}
        />
        <LoadingWrapper loading={isSaving} message='Sauvegarde en cours...' />
        <ModalError store={clientsStore} />
        <Toast store={clientsStore} toasts={clientsStore.toasts} />
        <Grid columns='equal'>
          <Grid.Row>
            <Grid.Column>
              <Header as='h1'>Nouveau client</Header>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <ClientPrincipalInformation
          clientsStore={clientsStore} canEdit editMode
          canSendEmailLogin={false}
        />
        <AddressInformation clientsStore={clientsStore} canEdit />
        <Grid columns='equal'>
          <Grid.Row>
            <Grid.Column>
              <Confirm
                open={saveConfirm}
                content='Êtes-vous sûr de vouloir créer un nouveau client?'
                confirmButton='Oui'
                cancelButton='Non'
                onCancel={() => { this.setState({ saveConfirm: false }) }}
                onConfirm={this.handleSaveClient}
              />
              <Button
                disabled={!clientsStore.isDirty || isSaving}
                content='Enregistrer'
                primary
                onClick={() => { this.setState({ saveConfirm: true }) }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    )
  }
}

export default ClientsCreateScreen
